import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';
import { LanguageContext } from '../context/LanguageContext';

export default function CV() {
  const { language } = useContext(LanguageContext);

  const texts = {
    EN: {
      title: "Wagner Orniz",
      location1: "São José do Rio Preto, SP, 1989",
      location2: "Lives and works in S. J. do Rio Preto/SP",
      bio: "Wagner Orniz, 35 years old, holds a Bachelor's degree in Fashion, a specialization in Digital Media, and a Master's degree in Discourse Analysis. He works as a transdisciplinary artist, researcher, and art/educator. His production is guided by the tension between modernity and tradition. Working with multiple supports, he narrates stories of different natures through performances, objects, installations, and images. He is interested in the imbrications between art, technology, and science, in geography and its social landscape, in artifacts created by man and nature.",
      educationTitle: "Education",
      education1: {
        period: "2021 - 2024",
        degree: "Master's in Linguistic Studies (Discourse Analysis)",
        institution: 'Universidade Estadual Paulista "Júlio de Mesquita Filho" - UNESP'
      },
      education2: {
        period: "2020 - 2022",
        degree: "Data Science (interrupted)",
        institution: "Universidade Virtual do Estado de São Paulo - UNIVESP"
      },
      education3: {
        period: "2012 - 2014",
        degree: "Postgraduate in Communication Management in Digital Media",
        institution: "Centro Universitário SENAC"
      },
      education4: {
        period: "2007 - 2010",
        degree: "Bachelor's in Fashion",
        institution: "Centro Universitário de Rio Preto - UNIRP"
      },
      exhibitionsTitle: "Selected Group Exhibitions",
      exhibition1: {
        period: "2022",
        exhibition: "1st Biennial of São José do Rio Preto",
        institution: "Casa de Cultura Dinorath do Valle"
      },
      exhibition2: {
        period: "2021",
        exhibition: "Perfidia",
        institution: "Centro Cultural Vasco"
      },
      exhibition3: {
        period: "2018",
        exhibition: "Tensão + (Dis)Tensão",
        institution: "SESC Rio Preto"
      },
      awardsTitle: "Awards", // New section title
      award1: { // New award entry
        period: "2022",
        award: "Gold Medal",
        institution: "1st Biennial of São José do Rio Preto"
      },
      back:"back"
    },
    PT: {
      title: "Wagner Orniz",
      location1: "São José do Rio Preto, SP, 1989",
      location2: "Vive e trabalha em S. J. do Rio Preto/SP",
      bio: "Wagner Orniz, 35 anos, é Bacharel em Moda, especialista em Mídias Digitais e mestre em Análise do Discurso. Atua como artista transdisciplinar, pesquisador e arte/educador. Sua produção é pautada pelo tensionamento entre modernidade e tradição. Trabalhando com suportes múltiplos, narra histórias de diferentes naturezas por meio de performances, objetos, instalações e imagens. Se interessa pelas imbricações entre arte, tecnologia e ciência, pela geografia e sua paisagem social, por artefatos criados pelo homem e pela natureza.",
      educationTitle: "Educação",
      education1: {
        period: "2021 - 2024",
        degree: "Mestrado em Estudos Linguísticos (Análise do discurso)",
        institution: 'Universidade Estadual Paulista "Júlio de Mesquita Filho" - UNESP'
      },
      education2: {
        period: "2020 - 2022",
        degree: "Ciência de Dados (interrompido)",
        institution: "Universidade Virtual do Estado de São Paulo - UNIVESP"
      },
      education3: {
        period: "2012 - 2014",
        degree: "Pós-graduação em Gestão da Comunicação em Mídias Digitais",
        institution: "Centro Universitário SENAC"
      },
      education4: {
        period: "2007 - 2010",
        degree: "Bacharelado em Moda",
        institution: "Centro Universitário de Rio Preto - UNIRP"
      },
      exhibitionsTitle: "Exposições Coletivas Selecionadas",
      exhibition1: {
        period: "2022",
        exhibition: "1ª Bienal de São José do Rio Preto",
        institution: "Casa de Cultura Dinorath do Valle"
      },
      exhibition2: {
        period: "2021",
        exhibition: "Perfídia",
        institution: "Centro Cultural Vasco"
      },
      exhibition3: {
        period: "2018",
        exhibition: "Tensão + (Dis)Tensão",
        institution: "SESC Rio Preto"
      },
      awardsTitle: "Premiações", // New section title in Portuguese
      award1: { // New award entry in Portuguese
        period: "2022",
        award: "Medalha de Ouro",
        institution: "1ª Bienal de São José do Rio Preto"
      },
      back:"retornar"
    }
  };

  const t = texts[language];

  return (
    <PageTransition>
      <div className="page-container">
        <Link to="/" className="back-button">&lt; {t.back}</Link>

        <div className="cv-content">
          <h1>{t.title}</h1>
          <p className="location">{t.location1}</p>
          <p className="location">{t.location2}</p>

          <div className="bio">
            <p className="bio-text">
              {t.bio}
            </p>
          </div>

          <div className="education">
            <h2>{t.educationTitle}</h2>
            <div className="education-item">
              <p><span>{t.education1.period}</span> | {t.education1.degree}</p>
              <p className="institution">{t.education1.institution}</p>
            </div>

            <div className="education-item">
              <p><span>{t.education2.period}</span> | {t.education2.degree}</p>
              <p className="institution">{t.education2.institution}</p>
            </div>

            <div className="education-item">
              <p><span>{t.education3.period}</span> | {t.education3.degree}</p>
              <p className="institution">{t.education3.institution}</p>
            </div>

            <div className="education-item">
              <p><span>{t.education4.period}</span> | {t.education4.degree}</p>
              <p className="institution">{t.education4.institution}</p>
            </div>
          </div>

          <div className="exhibitions">
            <h2>{t.exhibitionsTitle}</h2>
            <div className="exhibition-item">
              <p><span>{t.exhibition1.period}</span> | {t.exhibition1.exhibition}</p>
              <p className="institution">{t.exhibition1.institution}</p>
            </div>

            <div className="exhibition-item">
              <p><span>{t.exhibition2.period}</span> | {t.exhibition2.exhibition}</p>
              <p className="institution">{t.exhibition2.institution}</p>
            </div>

            <div className="exhibition-item">
              <p><span>{t.exhibition3.period}</span> | {t.exhibition3.exhibition}</p>
              <p className="institution">{t.exhibition3.institution}</p>
            </div>
          </div>
          {/* New Awards Section */}
          <div className="awards">
            <h2>{t.awardsTitle}</h2>
            <div className="exhibition-item">
              <p><span>{t.award1.period}</span> | {t.award1.award}</p>
              <p className="institution">{t.award1.institution}</p>
            </div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
}
